export default "__VITE_ASSET__82779123__"